import { createContext } from "react";

export interface TrackingPageRuntimeLayoutContextValue {
  /**
   * Reports an ephemeral content height for the live page. Passing null removes
   * the measurement and falls back to the block's saved grid height.
   */
  reportBlockHeight(blockId: string, height: number | null): void;
}

export const TrackingPageRuntimeLayoutContext = createContext<
  TrackingPageRuntimeLayoutContextValue | undefined
>(undefined);
